import classNames from "classnames";
import { PropsWithChildren } from "react";

type Props = {
  icon?: React.ReactNode;
  active?: boolean;
  onClick: () => void;
};

const Tab = ({ children, icon, active, onClick }: PropsWithChildren<Props>) => (
  <li className="mr-2 mb-0 list-none">
    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
    <a
      href="#"
      onClick={onClick}
      aria-current="page"
      className={classNames(
        "inline-flex p-4 border-b-2 rounded-t-lg group no-underline",
        {
          "border-transparent hover:text-gray-600 hover:border-gray-300":
            !active,
          "text-blue-600 border-blue-600 active": active,
        }
      )}
    >
      {icon && <span className="mr-2">{icon}</span>}
      {children}
    </a>
  </li>
);

export default Tab;
